/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Terms_Meta_DescriptionInputs */

const ja_playdata_terms_meta_description = /** @type {(inputs: Playdata_Terms_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYDATA（プレイデータ）の利用規約のページです。`)
};

const en_playdata_terms_meta_description = /** @type {(inputs: Playdata_Terms_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms of use for the PLAYDATA service.`)
};

/**
* | output |
* | --- |
* | "Terms of use for the PLAYDATA service." |
*
* @param {Playdata_Terms_Meta_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_terms_meta_description = /** @type {((inputs?: Playdata_Terms_Meta_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Terms_Meta_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_terms_meta_description(inputs)
	return en_playdata_terms_meta_description(inputs)
});